export const DATA_REPORT_ROOT = 'data_report_root';
export const API_SERVER_MONITOR = 'data_report_api_server_monitor';
export const API_CAPTCHA_MONITOR = 'data_report_api_captcha_monitor';

export const JS_DATA_MONITOR_ROOT = 'data_report_js_monitor_data_monitor_root';
// JS数据监控
export const JS_DATA_MONITOR = 'data_report_js_monitor_data_monitor';
// 双端日志
export const DOUBLE_END_MONITOR = 'data_report_js_monitor_double_end_monitor';
// 单端日志
export const SINGLE_END_MONITOR = 'data_report_js_monitor_single_end_monitor';
// 数据报表
export const JS_DATA_REPORT = 'data_report_js_monitor_data_report';
export const STRATEGY_ROOT = 'strategy_root';
// 策略管理 - JS策略
export const STRATEGY_JS_STRATEGY_MANAGE = 'strategy_manage_js_strategy';
// 策略管理 - 策略修改历史
export const STRATEGY_JS_STRATEGY_HISTORY = 'strategy_manage_js_strategy_history';
export const INTERVENE_ROOT = 'intervene_root';
// 干预管理 - JS设备干预
export const INTERVENE_JS_DEVICE_INTERVENE = 'intervene_js_device_intervene';
// 干预管理 - IP/设备指纹查询
export const INTERVENE_JS_DEVICE_QUERY = 'intervene_js_device_query';
// 用户管理
export const USER_MANAGE = 'user_manage';
// 个人信息
export const USER_INFO = 'user_info';
// 威胁情报
export const INTELLIGENCE = 'intelligence';
// 态势感知
export const SITUATION = 'situation';
// 介绍页
export const INTRODUCE_ROOT = 'introduce_root';
export const INTRODUCE_INDEX = 'introduce_index';
export const INTRODUCE_APPLY_ENTRANCE = 'introduce_apply_entrance';
export const INTRODUCE_APPLY_RESULT = 'introduce_apply_result';

// 登录页
export const LOGIN = 'login';

// 404
export const NOT_FOUND_PAGE = 'not_found_page';

// 接入管理
export const DOCK_MANAGE = 'dock_manage';
export const DOCK_DOMAIN_MANAGE = 'dock_manage_domain_manage';

export const DOCS = 'docs';

// 业务风险报告
export const BUSINESS_ANALYSE = 'business_analyse';